<template>
  <div >
    <van-form @submit="onSubmitFundDel">
      <base-date v-if="!emp.disable" v-model="qc.end_date" type="year-month" placeholder="请选择停缴时间" label="停缴时间" />
      <base-input v-model="qc.name" :rules="rules.name" :disabled="emp.disable" placeholder="请输入员工姓名" label="员工姓名" @focus="xa" />
      <base-input v-model="qc.id_card" :rules="rules.id_card" :disabled="emp.disabled" placeholder="请输入身份证号码" label="身份证号码" />
      <van-field v-if="!emp.disable" :value="cli.reduce_reason " readonly clickable name="picker" label="减员原因" placeholder="点击选择减员原因" @click="showPicker = true" />
      <!-- <base-button :disabled="submitDisabled" native-type="submit" class="btn">提交</base-button> -->

      <van-row type="flex" justify="space-between" style="text-align: center; padding-bottom: 10px;padding-top: 20px;">
        <van-col span="12"><van-button type="info" class="btn" @click="cancel">取消</van-button></van-col>
        <van-col span="12"><base-button :disabled="submitDisabled" type="info" native-type="submit" class="btn">提交</base-button></van-col>
      </van-row>
      <!-- <van-col span="8" style="">
        <span style="color: #9DC6FF; line-height: 44px;" @click="showPicker = true">{{ cli.reduce_reason ? cli.reduce_reason : '选择原因' }}</span>
      </van-col> -->
    </van-form>
    <div>
      <van-popup v-model="show" round position="bottom">
        <van-search v-model="emp.value" show-action label="姓名" placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-picker :columns="emp_name" show-toolbar @cancel="show = false" @confirm="onConfirm" />
      </van-popup>

      <van-popup v-model="showPicker" round position="bottom"><van-picker :columns="reduce_reason" show-toolbar @cancel="showPicker = false" @confirm="onConfirmS" /></van-popup>
    </div>
  </div>
</template>

<script>
import { Wxlist, ModifyX } from '@/api/Hremployee';
import { fundAdd } from '@/api/Hrfund';
import { billadd } from '@/api/Hrbill';
import { Toast } from 'vant';
export default {
  name: 'FundEmployeeDel',
  props: {
    qc: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      show: false,
      showPicker: false,
      emp: {
        value: '',
        disabled: true
      },
      empList: [],
      cli: {},
      message: '',
      emp_name: [],
      reduce_reason: ['合同到期', '主动离职', '辞退'],
      submitDisabled: false,
      rules: {
        name: [{ required: true, pattern: this.CONST.REG_EXP.PERSON_NAME, message: '姓名不能少于2个字符' }],
        id_card: [{ required: true, pattern: this.CONST.REG_EXP.ID_CARD, message: '输入的身份证号码不符合规范' }],
        mobile: [{ required: true, pattern: this.CONST.REG_EXP.MOBILE, message: '输入的手机号码不符合规范' }]
      }
    };
  },
  beforeMount() {
    if (sessionStorage.getItem('who') === '0') {
      this.emp.disable = false;
      this.qc.name = '';
      this.emp.status = 2;
      this.qc.id_card = '';
      this.query();
    } else {
      this.emp.disable = true;
    }
  },
  mounted() {},
  methods: {
    xa() {
      this.show = true;
      this.query();
    },
    cancel() {
      this.$emit('close');
    },
    onSearch() {
      this.query();
    },
    onConfirmS(value, index) {
      this.showPicker = false;
      this.cli.reduce_reason = value;
      this.cli.redu_id = index;
    },
    onConfirm(value, index) {
      if (this.empList[index].id_card === undefined) {
        this.emp.disabled = false;
        this.qc.id_card = '';
      } else {
        this.qc.id_card = this.empList[index].id_card;
        this.emp.disabled = true;
      }
      this.qc.name = this.emp_name[index].text;

      if (this.emp_name[index].disabled) {
        Toast('该员工已有工单请重新选择！');
      } else {
        this.show = false;
      }
      this.qc.phone = this.empList[index].phone;
      this.qc.emp_id = this.empList[index].id;
      if (this.empList[index].client_id !== undefined) {
        this.qc.client_id = this.empList[index].client_id;
      }
    },
    onSubmitFundDel() {
      this.submitDisabled = true;
      Toast.loading({
        message: '提交中',
        forbidClick: true
      });
      const qc = this._.cloneDeep(this.qc);

      billadd({
        client_id: parseInt(sessionStorage.getItem('client_id')),
        emp_id: qc.emp_id ? qc.emp_id : parseInt(sessionStorage.getItem('emp_id')),
        name: qc.name,
        reduce_month: qc.end_date ? qc.end_date : null,
        type: '公积金-减员',
        create_id: parseInt(sessionStorage.getItem('create_id')),
        status: this.emp.status ? this.emp.status : 1,
        phone: qc.phone,
        reduce_reason: (this.cli.redu_id + 1).toString(),
        id_card: qc.id_card,
        check_type: 1
      }).then(resp => {
        if (resp.success) {
          Toast.success('提交成功');
          this.$emit('close');
        } else {
          Toast.fail('提交失败');
        }
      });
    },
    query() {
      this.emp_name = [];
      this.empList = [];
      Wxlist({ client_id: parseInt(sessionStorage.getItem('client_id')), name: this.emp.value ? this.emp.value : null }).then(res => {
        for (let i = 0; i < res.rows.length; i++) {
          this.empList.push({
            id: res.rows[i].id,
            id_card: res.rows[i].id_card,
            name: res.rows[i].name,
            phone: res.rows[i].phone,
            client_id: res.rows[i].client_id
          });
          this.emp_name.push({ text: res.rows[i].name, disabled: true });
          if (res.rows[i].function_ids.indexOf('11') === 0 && res.rows[i].f_base !== undefined) {
            this.emp_name[i].disabled = false;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.btn {
  display: block;
  margin: 0 auto;
  margin-top: 100px;
  width: 80%;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/fund/employee-del.vue